/* Deprecated - please use app/assets/javascripts/react/shared/icons/ */

import PropTypes from 'prop-types';
import classNames from 'classnames';

const Icon = ({ size, title, type, className, onClick }) => (
  <i
    className={classNames(`icon-${type}`, className)}
    onClick={onClick}
    style={{ fontSize: size }}
    title={title}
  />
);

Icon.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  className: PropTypes.string,
};

Icon.defaultProps = {
  size: '1em',
};

export default Icon;
